module.exports = __webpack_public_path__ + "static/media/top-left.5b9c75e2.jpeg";